import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { About } from "./components/About";
import { Features } from "./components/Features";
import { Gallery } from "./components/Gallery";
import { Reviews } from "./components/Reviews";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingCallButton } from "./components/FloatingCallButton";
import { toast } from "sonner";

function App() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToGallery = () => {
    const gallerySection = document.getElementById('gallery');
    if (gallerySection) {
      gallerySection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLearnMore = (serviceTitle) => {
    toast.info(`Interested in ${serviceTitle}?`, {
      description: "Scroll down to contact us for more information"
    });
    setTimeout(scrollToContact, 1000);
  };

  return (
    <div className="App">
      <Header />
      <HeroSection 
        onBookConsultation={scrollToContact}
        onViewWork={scrollToGallery}
      />
      <About />
      <Features />
      <Gallery />
      <Reviews />
      <Contact />
      <Footer />
      <FloatingCallButton />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
